import { Action } from 'redux';
import { SpecialEnrollmentCircumstanceStateStructure } from '../interfaces/special-enrollment-circumstance.StateStructure.interface';
import { submittedAttemptProxyConnectPath } from 'src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface';

export const SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_NAME = 'special-enrollment-circumstance';

export const INITIAL_STATE: SpecialEnrollmentCircumstanceStateStructure = {
    dateOfLifeEvent: null,
    isApplicableCircumstance: null,
    lifeEvent: null
};

/** ACTION TYPES */
const SAVE_SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE = 'APPLY_FULL_SAVE_SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_STATE';
const DELETE_ALL_PROXY_VALUES = 'DELETE_ALL_PROXY_VALUES';
const CLEAR_ALL_PROXY_VALUES = 'CLEAR_ALL_PROXY_VALUES';
const CLEAR_PROXY_VALUE = 'CLEAR_PROXY_VALUE'
const SET_PROXY_VALUE = 'SET_PROXY_VALUE'

/** ACTIONS */
export class SpecialEnrollmentCircumstanceAction implements Action {
    type: string;
    specialEnrollmentCircumstanceState?: SpecialEnrollmentCircumstanceStateStructure;
    proxyValuePathArray?: string[];
    proxyValuePath?: string;
    proxyValue?: string | boolean;
}

export function saveSpecialEnrollmentCircumstanceState(specialEnrollmentCircumstanceState: SpecialEnrollmentCircumstanceStateStructure) {
  return { type: SAVE_SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE, specialEnrollmentCircumstanceState};
}

export function setProxyValue(proxyValuePath: string, proxyValue: string | boolean){
  return { type: SET_PROXY_VALUE, proxyValuePath, proxyValue }
}

export function deleteAllProxyValues(proxyValuePathArray: string[]): SpecialEnrollmentCircumstanceAction{
  return { type: DELETE_ALL_PROXY_VALUES, proxyValuePathArray};
}

export function clearAllProxyValues(proxyValuePathArray: string[]){
  return { type: CLEAR_ALL_PROXY_VALUES, proxyValuePathArray};
}


/** REDUCER */
export function SpecialEnrollmentCircumstance(
  state: SpecialEnrollmentCircumstanceStateStructure = INITIAL_STATE,
  action: SpecialEnrollmentCircumstanceAction
) {
  const copiedState: SpecialEnrollmentCircumstanceStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE:
        return Object.assign({}, action.specialEnrollmentCircumstanceState);
    case DELETE_ALL_PROXY_VALUES:
      let newState = Object.assign({}, state);
      for(const index in action.proxyValuePathArray){
        delete newState[action.proxyValuePathArray[index]];
      }
      return Object.assign({}, newState);
    case CLEAR_ALL_PROXY_VALUES:
      for(const index in action.proxyValuePathArray){
        if(action.proxyValuePathArray[index] === submittedAttemptProxyConnectPath){
          copiedState[action.proxyValuePathArray[index]] = false;
        }else{
          copiedState[action.proxyValuePathArray[index]] = null;
        }
      }
      return Object.assign({}, state, copiedState);
    case CLEAR_PROXY_VALUE:
      copiedState[action.proxyValuePath] = null;
      return Object.assign({}, state, copiedState);
    case SET_PROXY_VALUE: 
      copiedState[action.proxyValuePath] = action.proxyValue;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
